import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ErrorBoundary } from 'react-error-boundary';
import App from './app/App';
import store from './app/store';
import 'moment/locale/ko';
import { ToastContainer } from 'react-toastify';
import ErrorPage from './app/ErrorPage';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";


const queryClient = new QueryClient({
    defaultOptions:{
        queries:{
            staleTime: 1000*20,
            onError:(err)=>{
                console.log(err);
            },
            networkMode:'online',
            retry:false,
        }
    }
});

export const Root = () => (
    <ErrorBoundary FallbackComponent={ErrorPage} >
        <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter >
                <App />
                <ToastContainer stacked position="bottom-center" autoClose={5000} />
            </BrowserRouter>
        </QueryClientProvider>
        </Provider>
    </ErrorBoundary>
);